
<div class="page-content">

     <div><button class="btn-back" title="{{Button.Back_alt | translate}}" (click)="onPreviousClick()" translate>{{Button.Previous}}</button></div>

     <h1 class="page_title" translate>{{'provincial_payment.page_title'}}</h1>

     <div translate style="margin-bottom:2em">{{'provincial_payment.content1'}}</div>

     
     <div style="display:flex; justify-content:center">
          <div *ngIf="data.subject.siteKey">
                  <div [hidden]="data.isSubmit">
                              <re-captcha (resolved)="resolved($event)"  siteKey="{{data.subject.siteKey}}"> </re-captcha>     
                  </div>
          </div>
          
          <div class="wait-icon" [hidden]="!data.isSubmit" >
            <img src="refresh/assets/images/ChasingArrows.gif">
          </div>      
     </div>

     <div class="btn-div">

          <button class="btn-next" title="{{Button.Payment_alt|translate}}" 
                       [class.btn-disabled]="disabled" 
                       (click)="onNextClick()" 
                       [hidden]="data.isSubmit"
                       translate>{{Button.Next}}</button>
     </div>

</div>

